import React, { useContext, useEffect, useState } from 'react';
import './../styles/App.css';

import logo from './../images/logo.png';
import search from './../images/search.png';
import confirmed from './../images/галочка.png';
import doctor_icon from './../images/doctor_icon.png';
import MyModal from './UI/MyModal/MyModal';
import MyButton from './UI/MyButton/MyButton';
import { MainContext } from '..';
import { useNavigate } from 'react-router';
import { LOGIN_ROUTE } from '../utils/consts';
import { observer } from 'mobx-react-lite';
import { getOneEmployee } from '../API/employeeApi';
import { formatDoctorName } from '../utils/formatDoctorName';

const Navbar = observer(() => {
    const [isExitVisible, setIsExitVisible] = useState(false);
    const [userName, setUserName] = useState('');
    const navigate = useNavigate();
    const { user } = useContext(MainContext);
    const { ws } = useContext(MainContext);

    useEffect(() => {
        setUserName(formatDoctorName(user.user, user.employee));
    }, [user.user, user.employee]);

    const logOut = () => {
        if (window.confirm(`Выйти из аккаунта ${userName}?`)) {
            alert(`Выход из аккаунта ${userName})`);
            user.setIsAuth(false);
            user.setUser({});
            ws.close();
            localStorage.removeItem('access_token');
            navigate(LOGIN_ROUTE);
        } else {
            alert('Выход отменен');
        }
    };

    return (
        <div className="navbar">
            <img src={logo} className="navbar_logo" />
            <div className="navbar_btns">
                {/* <button className="search_btn">
                    <img src={search} className="icon" />
                    <div className="search">Поиск</div>
                </button> */}
                <div className="doctor" onClick={() => logOut()} title="Выйти">
                    <div className="name">{userName}</div>
                    <img src={confirmed} className="icon" />
                </div>
                <div className="doctor__icon">
                    <img src={doctor_icon} className="icon" />
                </div>
                {/* <div className="doctor__icon" onClick={() => setIsExitVisible(true)}>
                    <img src={doctor_icon} className="icon" />
                </div> */}
                {/* <MyModal visible={isExitVisible} setVisible={setIsExitVisible}>
                    <MyButton onClick={() => logOut()}>Выйти?</MyButton>
                    <MyButton onClick={() => setIsExitVisible(false)}>Отмена</MyButton>
                </MyModal> */}
            </div>
        </div>
    );
});

export default Navbar;
